/* G3D Contact page (sections/contact-page.liquid). The form is Shopify's real contact form: this only checks it before a normal post. */
(() => {
const root = document.querySelector('.g3d-ct');
if (!root) return;
const $ = id => document.getElementById('ct-' + id);
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const CDN = 'https://cdn.shopify.com/s/files/1/0989/5005/4192/files/';
const img = (f, w) => CDN + f + '?width=' + w;

// the form: a topic picks the frame colour and opens its drawer; JS validation with messages (native validation is the no-JS fallback)
const post = $('post'), form = document.getElementById('ContactForm-g3d'), ok = $('ok'), errSum = $('errSum');
const topics = [...root.querySelectorAll('.ct-topic input')];
// sent: the ball drops, wobbles three times and clicks shut, once (the reduced-motion rule keeps it static)
if (ok) ok.classList.add('ct-is-catching');
let tried = false, setTopic = () => {}, recheck = () => {};
if (topics.length) {
  const drawers = [...form.querySelectorAll('.ct-if')];
  const fields = [$('fPoke'), $('fName'), $('fEmail'), $('fBody')];
  const LABEL = { 'ct-fPoke': 'Pokémon or character', 'ct-fName': 'Name', 'ct-fEmail': 'Email', 'ct-fBody': 'Message' };
  const HOLDER = { order: 'Which order is it, and how can we help?', custom: 'Tell us about the ball: the pose, the details, anything special.',
    product: 'Which ball, and what would you like to know?', other: "What's on your mind?" };
  form.noValidate = true;
  tried = !!errSum.textContent.trim(); // Shopify sent it back with an error: re-check as you type, like after a failed send

  setTopic = k => {
    post.dataset.topic = k;
    // hidden drawers are disabled too, so their empty fields are neither checked nor sent
    drawers.forEach(d => { const on = d.dataset.if === k; d.hidden = !on; d.disabled = !on; });
    $('fPoke').required = k === 'custom';
    $('fBody').placeholder = HOLDER[k] || '';
    const r = topics.find(t => t.dataset.k === k);
    $('tPill').textContent = r ? r.value : 'No topic yet';
  };

  const emailOk = v => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
  const problem = el => {
    if (el.matches(':disabled')) return '';
    const v = el.value.trim();
    if (el.required && !v) return el.dataset.msg;
    if (el.type === 'email' && v && (!el.validity.valid || !emailOk(v))) return "That email doesn't look right. Check it for a typo.";
    return '';
  };
  const show = (el, msg) => {
    document.getElementById(el.getAttribute('aria-describedby').split(' ')[0]).textContent = msg;
    if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
  };
  const showTopic = msg => {
    $('eTopic').textContent = msg;
    topics.forEach(t => msg ? t.setAttribute('aria-invalid', 'true') : t.removeAttribute('aria-invalid'));
  };
  const validate = () => {
    const bad = [];
    const topicMsg = topics.some(t => t.checked) ? '' : 'Pick what your message is about.';
    showTopic(topicMsg);
    if (topicMsg) bad.push([topics[0], 'Topic']);
    fields.forEach(el => { const m = problem(el); show(el, m); if (m) bad.push([el, LABEL[el.id]]); });
    return bad;
  };
  const summary = bad => !bad.length ? '' : bad.length === 1 ? `One thing to fix: ${bad[0][1]}.` : `${bad.length} things to fix: ${bad.map(b => b[1]).join(', ')}.`;
  // after a failed send, the form re-checks on every change and keystroke: messages clear once fixed, and the summary follows
  // (it is only rewritten when its list changes, so the live region doesn't repeat itself while you type)
  recheck = () => {
    const t = summary(validate());
    if (errSum.textContent !== t) errSum.textContent = t;
  };
  form.addEventListener('change', e => {
    if (e.target.name === 'contact[Topic]') setTopic(e.target.dataset.k);
    if (tried) recheck();
  });
  form.addEventListener('input', e => { if (tried && fields.includes(e.target)) recheck(); });
  form.addEventListener('submit', e => {
    tried = true;
    const bad = validate();
    errSum.textContent = summary(bad);
    if (bad.length) { e.preventDefault(); bad[0][0].focus(); return; }
    // valid: nothing stops it, the browser posts the form to Shopify. Show that it's going, and block a second tap (a duplicate email)
    sendBtn.disabled = true; sendLbl.textContent = 'Sending…'; setTimeout(resetSend, 8000); // a captcha challenge that is closed or fails cancels the post with no pageshow
  });
  const sendBtn = form.querySelector('button[type="submit"]'), sendLbl = sendBtn.lastChild;
  // Back from Shopify's page: bfcache, or Firefox restoring the disabled state on a plain reload from history
  const resetSend = () => { sendBtn.disabled = false; sendLbl.textContent = 'Send message'; };
  addEventListener('pageshow', resetSend);
  const syncTopic = () => setTopic(topics.find(t => t.checked)?.dataset.k || '');
  syncTopic();
  addEventListener('DOMContentLoaded', syncTopic); // again after Shopify's form_key refill (after a captcha or error), which checks the radio without a change event
}

// "Request a custom ball" and friends, and the menu's Custom Requests (here only its hash would change): pick the topic, then bring the form into view
document.querySelectorAll('[data-pick], a[href$="/pages/contact#custom"]').forEach(a => a.addEventListener('click', e => {
  const r = topics.find(t => t.dataset.k === (a.dataset.pick || a.hash.slice(1)));
  if (!r) return; // after a send the link just scrolls to the card
  e.preventDefault();
  const drawer = a.closest('header-drawer');
  drawer?.close();
  r.checked = true;
  setTopic(r.dataset.k);
  if (tried) recheck();
  post.scrollIntoView({ block: 'start', behavior: REDUCED ? 'instant' : 'smooth' });
  // the menu drawer's focus trap stays on until its close animation ends
  drawer ? setTimeout(() => r.focus({ preventScroll: true }), 400) : r.focus({ preventScroll: true });
}));
// arriving with a topic in the address (/pages/contact#custom: the Custom Requests page redirects here), that topic is picked and
// the form brought into view; not after a send
const pre = topics.find(t => '#' + t.dataset.k === location.hash);
if (pre && !ok && !topics.some(t => t.checked)) { // a topic the browser restored wins
  pre.checked = true;
  setTopic(pre.dataset.k);
  post.scrollIntoView({ block: 'start' });
}

// hero: three photos ride the orbit and swap designs now and then (our own product photos; [front, shiny front])
const POOL = [
  ['CharizardFront_d6b72cdd-ba44-4762-974d-74792ff45a49.jpg', 'ShinyCharizardFront_d78f22ff-3e82-45dc-b9a0-4806d3e672bb.jpg'],
  ['MimikyuFront_c29784db-262b-460b-9a08-56090a11eab4.jpg', 'ShinyMimikyuFront_e3a77268-5e77-42be-810b-087d88bdc1e7.jpg'],
  ['SylveonFront_9eca6061-6519-453d-bd6d-ca38a1e0c5f9.jpg', 'ShinySylveonFront_27296b60-c7ad-4d9e-9a35-ca31049e6c0a.jpg'],
  ['KyogreFront_3482183c-8657-4756-abcb-bef5ddc3f19c.jpg', 'ShinyKyogreFront_7f6dd3ad-9d7f-4944-9e92-068e99e99b64.jpg'],
  ['MewFront.jpg', 'ShinyMewFront.jpg'],
  ['RayquazaFront_950ab504-0d77-4bda-896c-ec1ccf9652cd.jpg', 'ShinyRayquazaFront_09b855d7-32d5-4100-9922-39897f4f9431.jpg'],
  ['GroudonFront.jpg', 'ShinyGroudonFront_ebbb3c18-815c-43b6-9ae4-84e1e9c0be15.jpg'],
  ['UmbreonFront_e2256b54-1c22-4610-915d-f84d21db83b7.jpg', null],
  ['SleepingSnorlaxFront.jpg', null],
  ['PikaPonchoFront_afc84372-9cd0-4c14-b927-4dd1a75816fe.jpg', null],
  ['BulbasaurFront_20b32c40-b40a-49d3-ad9f-8b264177f525.jpg', null],
  ['DarkraiFront_7a6359fd-e9ba-4518-803a-6c5918b6c2ec.jpg', null]
];
const orbit = $('orbit'), orbs = [...root.querySelectorAll('.ct-orb')];
const onOrbit = [0, 1, 2];
function setOrb(orb, f, shiny) {
  const [a, b] = orb.querySelectorAll('img'), next = a.classList.contains('ct-is-hidden') ? a : b, prev = next === a ? b : a;
  next.onload = () => { next.classList.remove('ct-is-hidden'); prev.classList.add('ct-is-hidden'); orb.classList.toggle('ct-is-shiny', shiny); };
  next.src = img(f, 300);
}
let orbTurn = 0;
if (!REDUCED) setInterval(() => {
  if (orbit.classList.contains('ct-is-paused') || document.hidden || root.classList.contains('ct-is-still')) return;
  const k = orbTurn++ % 3, free = POOL.map((_, i) => i).filter(i => !onOrbit.includes(i)), i = free[Math.random() * free.length | 0], shiny = !!POOL[i][1] && Math.random() < .5;
  onOrbit[k] = i;
  setOrb(orbs[k], POOL[i][shiny ? 1 : 0], shiny);
}, 3400);
// Pause motion: the CSS loops hold (ct-is-still) and the swaps above wait; the label carries the state
const motion = $('motion');
motion.addEventListener('click', () => { motion.textContent = root.classList.toggle('ct-is-still') ? 'Play motion' : 'Pause motion'; });

// loops pause while unseen: the emblem off screen (24px of slack for the photos), plane B (1212-1679px) while the form card covers
// its flight or the footer its top edge. Plane B's watchers depend on the layout, so every resize rebuilds them
new IntersectionObserver(([e]) => orbit.classList.toggle('ct-is-paused', !e.isIntersecting), { rootMargin: '24px' }).observe(orbit);
const bg = root.querySelector('.cbg'), flyB = bg.querySelector('.cbg__fly--b'), foot = document.querySelector('#MainContent ~ footer'), coverB = [];
let watchers = [];
const watch = (el, rootMargin, fn) => { const o = new IntersectionObserver(([e]) => fn(e), { rootMargin }); o.observe(el); watchers.push(o); };
new ResizeObserver(() => {
  bg.querySelectorAll('.cbg__fly').forEach(bake);
  watchers.forEach(o => o.disconnect());
  watchers = [];
  if (!flyB.getClientRects().length) return; // plane B is hidden (below 1212px, or 500px tall or less): nothing to watch
  // each edge is a 1px line across the flight box (the plane reaches 14px above its route, 22px below, 48px sideways), the lower
  // one kept on screen; once the footer covers the top edge it covers everything below it
  const r = flyB.querySelector('.cbg__route').getBoundingClientRect(), W = document.documentElement.clientWidth, H = document.documentElement.clientHeight, top = r.top - 16;
  const setB = () => flyB.classList.toggle('ct-is-paused', top >= H || coverB[0] && coverB[1] || coverB[2]);
  coverB.length = 0;
  setB();
  [[post, top], [post, Math.min(r.bottom + 24, H - 1)], [foot, top]].forEach(([el, y], k) => el && watch(el, `${-y}px ${r.right + 48 - W}px ${y + 1 - H}px ${48 - r.left}px`, e => {
    coverB[k] = e.isIntersecting && !!e.rootBounds; // no rootBounds: a cross-origin frame (the theme editor) ignores rootMargin, so never pause there
    setB();
  }));
}).observe(bg);

// backdrop: each plane's route is sampled into translate/rotate keyframes (compositor-only, unlike offset-path), plus a resting
// pose for reduced motion. Only shown planes are sampled (phones show none): the resize watcher above bakes each once it shows
function bake(rig, i) {
  if (rig.dataset.baked || !rig.getClientRects().length) return;
  rig.dataset.baked = 1;
  const route = rig.querySelector('.cbg__route'), plane = rig.querySelector('.cbg__plane'), L = route.getTotalLength();
  const at = s => route.getPointAtLength(Math.min(L, Math.max(0, s)));
  let turn = 0;
  const pose = f => {
    const p = at(f * L), a = at(f * L - 2), b = at(f * L + 2);
    let deg = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
    deg += Math.round((turn - deg) / 360) * 360; // unwrapped, so the plane turns all the way round its loop
    turn = deg;
    return `translate(${p.x.toFixed(1)}px, ${p.y.toFixed(1)}px) rotate(${deg.toFixed(1)}deg)`;
  };
  plane.style.setProperty('--pose', pose(+plane.dataset.rest));
  turn = 0;
  root.append(Object.assign(document.createElement('style'), { textContent: `@keyframes cbgFly${i} {${Array.from({ length: 151 }, (_, k) => `${(k / 1.5).toFixed(2)}% { transform: ${pose(k / 150)}; }`).join('')}}` }));
  plane.style.animationName = 'cbgFly' + i;
}
})();
